/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetEntityLoaderDiagnosticsRequest {
    includeCatalogCoverage?: boolean;
}

/**
 * IntegrationMarketplaceAdminDiagnosticsApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceAdminDiagnosticsApiInterface
 */
export interface IntegrationMarketplaceAdminDiagnosticsApiInterface {
    /**
     * Returns auto-discovered EntityLoader beans: entity types, destination_table aliases, required load fields, and startup warnings from registry initialization.  Set includeCatalogCoverage=true to audit published integration catalog default_mappings destination_table values against the registry (uncovered tables block install/run for those mappings). 
     * @summary Entity loader registry diagnostics
     * @param {boolean} [includeCatalogCoverage] When true, include published catalog default_mappings destination coverage audit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceAdminDiagnosticsApiInterface
     */
    getEntityLoaderDiagnosticsRaw(requestParameters: GetEntityLoaderDiagnosticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns auto-discovered EntityLoader beans: entity types, destination_table aliases, required load fields, and startup warnings from registry initialization.  Set includeCatalogCoverage=true to audit published integration catalog default_mappings destination_table values against the registry (uncovered tables block install/run for those mappings). 
     * Entity loader registry diagnostics
     */
    getEntityLoaderDiagnostics(requestParameters: GetEntityLoaderDiagnosticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceAdminDiagnosticsApi extends runtime.BaseAPI implements IntegrationMarketplaceAdminDiagnosticsApiInterface {

    /**
     * Returns auto-discovered EntityLoader beans: entity types, destination_table aliases, required load fields, and startup warnings from registry initialization.  Set includeCatalogCoverage=true to audit published integration catalog default_mappings destination_table values against the registry (uncovered tables block install/run for those mappings). 
     * Entity loader registry diagnostics
     */
    async getEntityLoaderDiagnosticsRaw(requestParameters: GetEntityLoaderDiagnosticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['includeCatalogCoverage'] != null) {
            queryParameters['includeCatalogCoverage'] = requestParameters['includeCatalogCoverage'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/marketplace/diagnostics/entity-loaders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns auto-discovered EntityLoader beans: entity types, destination_table aliases, required load fields, and startup warnings from registry initialization.  Set includeCatalogCoverage=true to audit published integration catalog default_mappings destination_table values against the registry (uncovered tables block install/run for those mappings). 
     * Entity loader registry diagnostics
     */
    async getEntityLoaderDiagnostics(requestParameters: GetEntityLoaderDiagnosticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getEntityLoaderDiagnosticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
